(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
    const containers = document.querySelectorAll('[data-accelerated-checkout-text]');
    if (!containers.length) return;

    for (const container of containers) {
      const customText = container.getAttribute('data-accelerated-checkout-text');
      if (!customText) continue;

      const applyText = () => {
        const button = container.querySelector('.shopify-payment-button__button');
        if (!button) return;

        button.textContent = customText;
      };

      applyText();

      const observer = new MutationObserver(() => {
        applyText();
      });

      observer.observe(container, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jv-benefit-card"] && !Shopify.designMode) return;
  try {
    (function() {
    // Autoplay
    const benefitCards = document.querySelectorAll('.jv-benefit-cards[data-autoplay="true"]');
    
    benefitCards.forEach(function(container) {
      // Apenas no mobile
      if (window.innerWidth >= 750) return;
      
      const cards = container.querySelectorAll('.jv-benefit-card');
      if (cards.length <= 2) return; // Não precisa autoplay se todos os cards estão visíveis
      
      const autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;
      let autoplayInterval = null;
      let isUserInteracting = false;
      let scrollTimeout = null;
      
      function scrollToNext() {
        if (isUserInteracting) return;
        
        const scrollLeft = container.scrollLeft;
        const cardWidth = cards[0].offsetWidth;
        const gap = parseFloat(getComputedStyle(container).gap) || parseFloat(getComputedStyle(container).columnGap) || 0;
        const cardWithGap = cardWidth + gap;
        const maxScroll = container.scrollWidth - container.clientWidth;
        
        // Calcula o índice atual
        let currentIndex = Math.round(scrollLeft / cardWithGap);
        
        // Se está muito próximo do final, considera que está no último card
        if (scrollLeft >= maxScroll - 10) {
          currentIndex = cards.length - 1;
        }
        
        // Calcula o próximo índice (com loop)
        let nextIndex = currentIndex + 1;
        
        // Se chegou no último card, volta para o primeiro
        if (nextIndex >= cards.length) {
          nextIndex = 0;
        }
        
        // Scroll suave para o próximo card
        container.scrollTo({
          left: nextIndex * cardWithGap,
          behavior: 'smooth'
        });
      }
      
      function startAutoplay() {
        if (autoplayInterval || window.innerWidth >= 750) return;
        autoplayInterval = setInterval(scrollToNext, autoplaySpeed);
      }
      
      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }
      
      // Pausar autoplay quando usuário interage
      container.addEventListener('touchstart', function() {
        isUserInteracting = true;
        stopAutoplay();
      });
      
      container.addEventListener('touchend', function() {
        setTimeout(function() {
          isUserInteracting = false;
          startAutoplay();
        }, 2000); // Retoma após 2 segundos sem interação
      });
      
      container.addEventListener('scroll', function() {
        isUserInteracting = true;
        stopAutoplay();
        
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          isUserInteracting = false;
          startAutoplay();
        }, 2000);
      });
      
      // Pausar no hover (desktop)
      container.addEventListener('mouseenter', stopAutoplay);
      container.addEventListener('mouseleave', function() {
        if (window.innerWidth < 750) {
          startAutoplay();
        }
      });
      
      // Iniciar autoplay
      startAutoplay();
      
      // Reiniciar autoplay ao redimensionar (se voltar para mobile)
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          stopAutoplay();
          if (window.innerWidth < 750 && cards.length > 2) {
            startAutoplay();
          }
        }, 250);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
